import { render } from "./CreatorFaq.vue?vue&type=template&id=02761e8c"
import script from "./CreatorFaq.vue?vue&type=script&lang=js"
export * from "./CreatorFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__